    /*********************** Custom JS for Boost AI Search & Discovery  ************************/
const updateProductItem3 = (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
        name: 'Add SKU and specsheet to product card',
        enabled: true,
        apply: () => ({
            afterRender(element){
                try{
                    let productData = element.getParams()?.props?.product || element.getParams()?.props?.productData || element.getParams()?.props?.data;
                    let productItem = document.querySelector('[data-product-id="'+ productData.id +'"]');
                    if(!productItem) return;

                    // if (typeof Samita !== 'undefined' && typeof Samita.ProductLabels !== 'undefined') {
                    //   Samita.ProductLabels.initialize();
                    // }

                    let oosBtn = productItem.querySelector('.boost-sd__product-price');
                    if (oosBtn && !productData.available) {
                      var oosBtnHtml = '<button type="button" name="add" class="boost-sd__oos-btn disabled" data-label="Add to Cart" disabled="disabled"> <span class="text">Contact For Availability</span></button>';
                      if(!oosBtn.querySelector('.boost-sd__oos-btn')) {
                        oosBtn.innerHTML = oosBtnHtml;
                      }
                    }

                    // Set link for ajax
                    let productHandleAjax = Shopify.routes.root + 'products/'+ productData.handle + '?view=boost-sd-custom-integration';
                    let requestReg = formRequest(productHandleAjax);
                    requestReg.then((res_success) => {
                        let parse_res_success = JSON.parse(res_success);
                        // Render Ajax Data
                        let itemEls = document.querySelectorAll(`[id='${parse_res_success.id}']`);
                        itemEls.forEach(itemEl => {
                          if(itemEl.querySelector('.boost-sd__product-item-grid-view-layout-image')) {
                            itemEl.classList.add('thumbnail')
                            itemEl.querySelector('.boost-sd__product-item-grid-view-layout-image').insertAdjacentHTML('beforeend', parse_res_success.price_ui_badges);
                          }
                        })
                    }).catch((res_error) => {
                            console.error(res_error)
                    });
                } catch (e) {
                }
            }
        }),

    });
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([updateProductItem3]);

function formRequest(value) {
  return new Promise((resolve, reject) => {
      var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
      xhr.open("GET", value);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = () => resolve(xhr.responseText);
      xhr.onerror = () => reject(xhr.statusText);
      xhr.send();
  });
}
